import { EvaluationAPI } from '@/api/evaluation.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import { Evaluation } from '@/models/evaluation'

const evaluationAPI = new EvaluationAPI()

const create = (body: Evaluation): AxiosObservable<Evaluation> => evaluationAPI.create(body)


export default { create }
